import { text } from './text';

const palette = {
  50: '#f8e3e9',
  100: '#f6dbe3',
  200: '#e28ca4',
  300: '#d76182',
  400: '#ce4569',
  500: '#c82a52',
  600: '#b92750',
  700: '#a43152',
  800: '#901e46',
  900: '#6d163d',
};

export const red = {
  ...palette,
  light: palette[300],
  main: palette[600],
  dark: palette[800],
  contrastText: text.contrast,
};
